import { render, staticRenderFns } from "./FuelFundsSidebar.vue?vue&type=template&id=2568fc2c&"
import script from "./FuelFundsSidebar.vue?vue&type=script&lang=js&"
export * from "./FuelFundsSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2568fc2c')) {
      api.createRecord('2568fc2c', component.options)
    } else {
      api.reload('2568fc2c', component.options)
    }
    module.hot.accept("./FuelFundsSidebar.vue?vue&type=template&id=2568fc2c&", function () {
      api.rerender('2568fc2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/fuel-funds/FuelFundsSidebar.vue"
export default component.exports